(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lts-licence-explainer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLce(root) {
    if (!root || root.dataset.lceReady) return;
    var tabs = [].slice.call(root.querySelectorAll('[data-lce-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-lce-panel]'));
    var ind = root.querySelector('.lts-lce-tab-ind');
    if (tabs.length < 2) return;            // 0/1 licences: leave stacked
    root.dataset.lceReady = '1';
    root.classList.add('lts-lce-js');       // switch on tab mode

    function moveInd(tab) {
      if (!ind || !tab) return;
      ind.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
      ind.style.width = tab.offsetWidth + 'px';
    }
    function activate(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (pn, j) {
        var on = j === i;
        pn.classList.toggle('is-active', on);
        if (on) { pn.removeAttribute('hidden'); }
        else { pn.setAttribute('hidden', ''); }
      });
      moveInd(tabs[i]);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i); });
      tab.addEventListener('keydown', function (e) {
        var n = null, last = tabs.length - 1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = last;
        if (n !== null) { e.preventDefault(); activate(n, true); }
      });
    });

    // initial: hide non-active panels, place the indicator
    panels.forEach(function (pn) { if (!pn.classList.contains('is-active')) pn.setAttribute('hidden', ''); });
    function placeInit() { moveInd(root.querySelector('.lts-lce-tab.is-active') || tabs[0]); }
    placeInit();
    // re-measure once webfont (Nunito) settles, and on resize
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeInit);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(placeInit, 120); });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-lts-lce]'), initLce); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var r = (e.target || document).querySelector('[data-lts-lce]');
    if (r) { delete r.dataset.lceReady; r.classList.remove('lts-lce-js'); initLce(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lts-licence-table"] && !Shopify.designMode) return;
  try {
    
// Live column-header prices: react to the size picker's lts:size-change event.
// When a band is set, show that band's exact price for each column product and
// drop the "from" prefix; when band is null, restore the SSR "from $X" fallback.
// Self-contained: depends only on the document event + the #lts-lct-prices blob.
(function(){
  var blobEl = document.getElementById('lts-lct-prices');
  if (!blobEl) return;
  var PRICES;
  try { PRICES = JSON.parse(blobEl.textContent || '{}'); }
  catch (e) { return; } // malformed blob: leave SSR fallback untouched

  // Mirror the pricing builder's money(): whole dollars, cents only if present.
  function money(n){
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }

  // Cache each column's price element + its SSR "from $X" fallback (affix + price)
  // so band:null can restore exactly what the server rendered.
  var cols = {};
  var prEls = document.querySelectorAll('.lts-lct-pr[data-col]');
  for (var i = 0; i < prEls.length; i++){
    var el = prEls[i];
    var col = el.getAttribute('data-col');
    var affix = el.querySelector('[data-affix]');
    var price = el.querySelector('[data-price]');
    if (!price) continue;
    cols[col] = {
      affix: affix,
      price: price,
      ssrAffix: affix ? affix.textContent : '',
      ssrPrice: price.textContent
    };
  }

  function apply(band){
    for (var col in cols){
      if (!cols.hasOwnProperty(col)) continue;
      var c = cols[col];
      var bandPrice = (band != null && PRICES[col]) ? PRICES[col][String(band)] : undefined;
      if (band != null && bandPrice != null){
        // Exact band price: drop the "from" affix, show the number.
        if (c.affix) c.affix.textContent = '';
        c.price.textContent = money(bandPrice);
      } else {
        // No band (or missing price): restore the SSR "from $X" fallback.
        if (c.affix) c.affix.textContent = c.ssrAffix;
        c.price.textContent = c.ssrPrice;
      }
    }
  }

  document.addEventListener('lts:size-change', function(e){
    var band = (e && e.detail) ? e.detail.band : null;
    apply(band);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-team-bio"] && !Shopify.designMode) return;
  try {
    
  // subtle scroll-reveal for body blocks (hero animates via CSS keyframes)
  (function(){
    if(!('IntersectionObserver' in window)) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els=[].slice.call(document.querySelectorAll('.tb-body .tb-seg, .tb-body .tb-note, .tb-body figure.photo'));
    if(!els.length) return;
    els.forEach(function(el){ el.classList.add('tb-anim'); });
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{ rootMargin:'0px 0px -8% 0px', threshold:0.08 });
    els.forEach(function(el){ io.observe(el); });
    // failsafe: never leave content hidden (crawlers, no-scroll renders, background tabs)
    setTimeout(function(){ els.forEach(function(el){ el.classList.add('is-in'); }); }, 1400);
  })();

  (function(){
    var content=document.getElementById('tb-content');
    if(!content) return;
    function esc(s){return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
    function readJSON(id){try{var el=document.getElementById(id);return el?JSON.parse(el.textContent):null;}catch(e){return null;}}

    // render Shopify rich_text AST -> HTML (metaobject fields don't auto-render)
    function rt(n){
      if(!n) return '';
      if(Array.isArray(n)) return n.map(rt).join('');
      var kids=(n.children||[]).map(rt).join('');
      switch(n.type){
        case 'root': return kids;
        case 'paragraph': return '<p>'+kids+'</p>';
        case 'heading': var l=Math.min(Math.max(n.level||2,2),4); return '<h'+l+'>'+kids+'</h'+l+'>';
        case 'list': var tag=(n.listType==='ordered')?'ol':'ul'; return '<'+tag+'>'+kids+'</'+tag+'>';
        case 'list-item': return '<li>'+kids+'</li>';
        case 'link':
          var u=esc(n.url||'#'), ti=n.title?' title="'+esc(n.title)+'"':'', tg=n.target?' target="'+esc(n.target)+'" rel="noopener"':'';
          return '<a href="'+u+'"'+ti+tg+'>'+kids+'</a>';
        case 'text':
          var s=esc(n.value||''); if(n.bold) s='<strong>'+s+'</strong>'; if(n.italic) s='<em>'+s+'</em>'; return s;
        default: return kids;
      }
    }
    var contentAst=readJSON('tb-content-data');
    if(contentAst){ content.innerHTML=rt(contentAst); }

    var blocks=Array.prototype.slice.call(content.children);
    var after=0; // insert position pointer within blocks

    // quote sticky note after the first block
    var q=readJSON('tb-quote');
    if(q&&q.text&&blocks.length){
      var note=document.createElement('div');
      note.className='tb-note';
      note.innerHTML='<div class="tb-note__card"><span class="tb-pin"></span>'
        +'<div class="tb-note__q">“'+esc(q.text)+'”</div>'
        +(q.cite?'<span class="tb-note__c">— '+esc(q.cite)+'</span>':'')+'</div>';
      blocks[0].insertAdjacentElement('afterend', note);
      after=1;
    }

    // weave photos through the remaining blocks, alternating sides
    var photos=(readJSON('tb-photos')||[]).filter(function(p){return p&&p.img;});
    if(photos.length){
      function fig(p,i){
        var f=document.createElement('figure');
        f.className='weave '+(i%2?'right':'left');
        f.innerHTML='<div class="grid"><div class="ph"><img src="'+esc(p.img)+'" alt="" loading="lazy"></div>'
          +'<figcaption>'+(p.year?'<span class="yr">'+esc(p.year)+'</span>':'')
          +(p.title?'<div class="cap">'+esc(p.title)+'</div>':'')+'</figcaption></div>';
        return f;
      }
      var remaining=blocks.slice(after+1);
      if(!remaining.length){ photos.forEach(function(p,i){content.appendChild(fig(p,i));}); return; }
      var step=Math.max(1, Math.floor(remaining.length/(photos.length+1)));
      var pi=0;
      for(var i=step-1;i<remaining.length && pi<photos.length;i+=step){
        remaining[i].insertAdjacentElement('afterend', fig(photos[pi],pi)); pi++;
      }
      while(pi<photos.length){ content.appendChild(fig(photos[pi],pi)); pi++; }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
